import {Injectable} from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class SelectedAccountService {

    constructor() {
    }


    // DISTRIBUTOR
    private _selectedDistributorId: number;

    public get getSelectedDistributorId() {
        return this._selectedDistributorId;
    }

    private _selectedDistributorName: string;

    public get getSelectedDistributorName() {
        return this._selectedDistributorName;
    }

    public async setSelectedDistributor(id: number, name: string) {
        this._selectedDistributorId = id;
        this._selectedDistributorName = name;
    }

    public clearSelectedDistributor() {
        this._selectedDistributorId = undefined;
        this._selectedDistributorName = undefined;
    }

    public get distributorId() {
        return this._selectedDistributorId ? this._selectedDistributorId : 0;
    }

    // GROUP
    private _selectedGroupId: number;

    public get getSelectedGroupId() {
        return this._selectedGroupId;
    }

    private _selectedGroupName: string;

    public get getSelectedGroupName() {
        return this._selectedGroupName;
    }

    public async setSelectedGroup(id: number, name: string) {
        this._selectedGroupId = id;
        this._selectedGroupName = name;
    }

    public clearSelectedGroup() {
        this._selectedGroupId = undefined;
        this._selectedGroupName = undefined;

        this.clearSelectedGroupEvent();
    }

    public get groupId() {
        return this._selectedGroupId ? this._selectedGroupId : 0;
   }

   //Business Activity
   private _selectedLaboratoryGroupBusinessActivityId: number;

   public get getSelectedLaboratoryGroupBusinessActivityId() {
      return this._selectedLaboratoryGroupBusinessActivityId;
   }

   private _selectedBusinessActivityId: number;

   public get getSelectedBusinessActivityId() {
      return this._selectedBusinessActivityId;
   }

   private _selectedBusinessActivityName: string;

   public get getSelectedBusinessActivityName() {
      return this._selectedBusinessActivityName;
   }

   public async setSelectedBusinessActivity(id: number, name: string, gid: number = null) {
      this._selectedBusinessActivityId = id;
      this._selectedBusinessActivityName = name;
      this._selectedLaboratoryGroupBusinessActivityId = gid;
   }

   public clearSelectedBusinessActivity() {
      this._selectedLaboratoryGroupBusinessActivityId = undefined;
      this._selectedBusinessActivityId = undefined;
      this._selectedBusinessActivityName = undefined;
   }

   public get businessActivityId() {
      return this._selectedBusinessActivityId ? this._selectedBusinessActivityId : 0;
   }

    // SITE
    private _selectedSiteId: number;

    public get getSelectedSiteId() {
        return this._selectedSiteId;
    }

    private _selectedSiteName: string;

    public get getSelectedSiteName() {
        return this._selectedSiteName;
    }

    public async setSelectedSite(id: number, name: string) {
        this._selectedSiteId = id;
        this._selectedSiteName = name;
    }

    public clearSelectedSite() {
        this._selectedSiteId = undefined;
        this._selectedSiteName = undefined;

        this.clearSelectedSiteEvent();
    }

    public get siteId() {
        return this._selectedSiteId ? this._selectedSiteId : 0;
    }

    // ACCOUNT
    private _selectedAccountId: number;

    public get getSelectedAccountId() {
        return this._selectedAccountId;
    }

    private _selectedAccountName: string;

    public get getSelectedAccountName() {
        return this._selectedAccountName;
    }

    public async setSelectedAccount(id: number, name: string) {
        this._selectedAccountId = id;
        this._selectedAccountName = name;
    }

    public clearSelectedAccount() {
        this._selectedAccountId = undefined;
        this._selectedAccountName = undefined;
    }

    public get accountId() {
        return this._selectedAccountId ? this._selectedAccountId : 0;
    }

    // PROPERTY
    private _selectedPropertyId: number;

    public get getSelectedPropertyId() {
        return this._selectedPropertyId;
    }

    private _selectedPropertyName: string;

    public get getSelectedPropertyName() {
        return this._selectedPropertyName;
    }

    public async setSelectedProperty(id: number, name: string) {
        this._selectedPropertyId = id;
        this._selectedPropertyName = name;
    }

    public clearSelectedProperty() {
        this._selectedPropertyId = undefined;
        this._selectedPropertyName = undefined;
    }

    public get propertyId() {
        return this._selectedPropertyId ? this._selectedPropertyId : 0;
   }
    
    // SHARED DATA
    private _selectedCountryId: number;

    public get getSelectedCountryId() {
        return this._selectedCountryId;
    }

    private _selectedCountryName: string;

    public get getSelectedCountryName() {
        return this._selectedCountryName;
    }

    public setSelectedCountry(id: number, name: string) {
        this._selectedCountryId = id;
        this._selectedCountryName = name;
    }

    public clearSelectedCountry() {
        this._selectedCountryId = undefined;
        this._selectedCountryName = undefined;
    }

    private _selectedEventId: number;

    public get getSelectedEventId() {
        return this._selectedEventId;
    }

    private _selectedEventName: string;

    public get getSelectedEventName() {
        return this._selectedEventName;
    }

    public setSelectedEvent(id: number, name: string) {
        this._selectedEventId = id;
        this._selectedEventName = name;
    }

    public clearSelectedEvent() {
        this._selectedEventId = undefined;
        this._selectedEventName = undefined;
    }

    private _selectedGroupEventId: number;

    public get getSelectedGroupEventId() {
        return this._selectedGroupEventId;
    }

    private _selectedGroupEventName: string;

    public get getSelectedGroupEventName() {
        return this._selectedGroupEventName;
    }

    public setSelectedGroupEvent(id: number, name: string) {
        this._selectedGroupEventId = id;
        this._selectedGroupEventName = name;
    }

    public clearSelectedGroupEvent() {
        this._selectedGroupEventId = undefined;
        this._selectedGroupEventName = undefined;
   }

   private _selectedSampleIssueId: number;

   public get getSelectedSampleIssueId() {
      return this._selectedSampleIssueId;
   }

   private _selectedSampleIssueName: string;

   public get getSelectedSampleIssueName() {
      return this._selectedSampleIssueName;
   }

   public setSelectedSampleIssue(id: number, name: string) {
      this._selectedSampleIssueId = id;
      this._selectedSampleIssueName = name;
   }

   public clearSelectedSampleIssue() {
      this._selectedSampleIssueId = undefined;
      this._selectedSampleIssueName = undefined;
   }

    private _selectedSiteEventId: number;

    public get getSelectedSiteEventId() {
        return this._selectedSiteEventId;
    }

    private _selectedSiteEventName: string;

    public get getSelectedSiteEventName() {
        return this._selectedSiteEventName;
    }

    public setSelectedSiteEvent(id: number, name: string) {
        this._selectedSiteEventId = id;
        this._selectedSiteEventName = name;
    }

    public clearSelectedSiteEvent() {
        this._selectedSiteEventId = undefined;
        this._selectedSiteEventName = undefined;
    }

    private _selectedSpeciesId: number;

    public get getSelectedSpeciesId() {
        return this._selectedSpeciesId;
    }

    private _selectedSpeciesName: string;

    public get getSelectedSpeciesName() {
        return this._selectedSpeciesName;
    }

    public setSelectedSpecies(id: number, name: string) {
        this._selectedSpeciesId = id;
        this._selectedSpeciesName = name;
    }

    public clearSelectedSpecies() {
        this._selectedSpeciesId = undefined;
        this._selectedSpeciesName = undefined;
    }

    private _selectedSeasonId: number;

    public get getSelectedSeasonId() {
        return this._selectedSeasonId;
    }

    private _selectedSeasonName: string;

    public get getSelectedSeasonName() {
        return this._selectedSeasonName;
    }

    public setSelectedSeason(id: number, name: string) {
        this._selectedSeasonId = id;
        this._selectedSeasonName = name;
    }

    public clearSelectedSeason() {
        this._selectedSeasonId = undefined;
        this._selectedSeasonName = undefined;
    }

    private selectedProductId: number;

    public get getSelectedProductId() {
        return this.selectedProductId;
    }

    private selectedProductName: string;

    public get getSelectedProductName() {
        return this.selectedProductName;
    }

    public async setSelectedProduct(id: number, name: string) {
        this.selectedProductId = id;
        this.selectedProductName = name;
    }

    public clearSelectedProduct() {
        this.selectedProductId = undefined;
        this.selectedProductName = undefined;
    }

    private selectedTestId: number;

    public get getSelectedTestId() {
        return this.selectedTestId;
    }

    private selectedTestName: string;

    public get getSelectedTestName() {
        return this.selectedTestName;
    }

    public async setSelectedTest(id: number, name: string) {
        this.selectedTestId = id;
        this.selectedTestName = name;
    }

    public clearSelectedTest() {
        this.selectedTestId = undefined;
        this.selectedTestName = undefined;
    }

    private selectedSubscriptionId: number;

    public get getSelectedSubscriptionId() {
        return this.selectedSubscriptionId;
    }

    private selectedSubscriptionName: string;

    public get getSelectedSubscriptionName() {
        return this.selectedSubscriptionName;
    }

    public async setSelectedSubscription(id: number, name: string) {
        this.selectedSubscriptionId = id;
        this.selectedSubscriptionName = name;
    }

    public clearSelectedSubscription() {
        this.selectedSubscriptionId = undefined;
        this.selectedSubscriptionName = undefined;
    }

    private selectedParticleId: number;

    public get getSelectedParticleId() {
        return this.selectedParticleId;
    }

    private selectedParticleName: string;

    public get getSelectedParticleName() {
        return this.selectedParticleName;
    }

    public async setSelectedParticle(id: number, name: string) {
        this.selectedParticleId = id;
        this.selectedParticleName = name;
    }

    public clearSelectedParticle() {
        this.selectedParticleId = undefined;
        this.selectedParticleName = undefined;
    }
    
    private selectedParticleGroupId: number;

    public get getSelectedParticleGroupId() {
        return this.selectedParticleGroupId;
    }

    private selectedParticleGroupName: string;

    public get getSelectedParticleGroupName() {
        return this.selectedParticleGroupName;
    }

    public async setSelectedParticleGroup(id: number, name: string) {
        this.selectedParticleGroupId = id;
        this.selectedParticleGroupName = name;
    }

    public clearSelectedParticleGroup() {
        this.selectedParticleGroupId = undefined;
        this.selectedParticleGroupName = undefined;
    }
}
